import conf from 'conf'

import { getOfficemailDomain } from './info'

const officemailDomain = getOfficemailDomain()

const defaultAppConfig = {
  AppEnterpriseServerAddr: conf.SERVER.restURL, // 'https://api.officemail.io',
  AppServiceUseSSL: true,
  UserFontFamily: 'Aptos, Calibri, Arial, Helvetica, sans-serif',
  UserFontSize: 11,
  UserFontColor: '#000000',
  UserReplyFontColor: '#1F497D',
  UserSignature: '<div><br /></div>',
  BrandingName: '',
  BrandingSplashColor: '',
  BrandingLogo: '',
  BrandingLogoForDark: '',
  BrandingSplashLogo: '',
  AllowMultipleAccounts: false,
  AllowEmailSync: true,
  AllowCalendarSync: true,

  AllowContactsSync: true,
  AllowTasksSync: true,
  AllowNotesSync: true,
  AllowShareAttachment: true,
  AllowSaveAttachment: true,
  AllowShareContents: true,
  AllowCopyPaste: true,
  AllowScreenShot: true,
}

const appConfigForType = {
  office365: {
    AppServiceHosts: 'outlook.office365.com',
    AppEmailServiceProvider: 'Exchange',
    AppAuthenticationMethod: 'Modern',
    AppServicePort: 443,
    UserPinnedApps: ['Email', 'Calendar', 'Contacts', 'To Do'],
  },
  exchange: {
    AppEmailServiceProvider: 'Exchange',
    AppAuthenticationMethod: 'Basic',
    AppServicePort: 443,
    UserPinnedApps: ['Email', 'Calendar', 'Contacts', 'To Do'],
  },
  google: {
    AppServiceHosts: 'm.google.com',
    AppEmailServiceProvider: 'Google Workspace',
    AppAuthenticationMethod: 'OAuth2',
    AppServicePort: 443,
    UserPinnedApps: ['Email', 'Calendar', 'Contacts', 'To Do'],
  },
  imap: {
    AppEmailServiceProvider: 'IMAP',
    AppAuthenticationMethod: 'Basic',
    UserPinnedApps: ['Email', 'Notes'],
  },
  officemail: {
    AppServiceHosts: `imap.${officemailDomain}`,
    AppEmailServiceProvider: 'OfficeMail',
    AppAuthenticationMethod: 'OAuth2',
    AppServicePort: 993,
    AppServiceTransmissionProtocol: 0,
    AppSMTPConfiguration: {
      ServerAddress: `smtp.${officemailDomain}`,
      ServerPort: 465,
      TransportSecurity: 0,
    },
    UserPinnedApps: ['Email', 'Calendar', 'Contacts', 'Notes'],
    AppCardDAVConfiguration: {
      ServerAddress: `carddav.${officemailDomain}`,
      ServerPort: 443,
      TransportSecurity: 0,
    },
    AppCalDAVConfiguration: {
      ServerAddress: `caldav.${officemailDomain}`,
      ServerPort: 443,
      TransportSecurity: 0,
    },
  },
}

export default function getDefaultAppConfig(type) {
  return {
    ...appConfigForType[type],
    ...defaultAppConfig,
  }
}
